import { render, staticRenderFns } from "./HeaderDots.vue?vue&type=template&id=bbee61e6&"
import script from "./HeaderDots.vue?vue&type=script&lang=js&"
export * from "./HeaderDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports